export * from './simple-layout.component';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/containers/simple-layout/index.ts